import { render, staticRenderFns } from "./importCollectionItemsModal.vue?vue&type=template&id=51b31bd5&scoped=true&"
import script from "./importCollectionItemsModal.vue?vue&type=script&lang=js&"
export * from "./importCollectionItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./importCollectionItemsModal.vue?vue&type=style&index=0&id=51b31bd5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b31bd5",
  null
  
)

export default component.exports